import { useState, useEffect } from 'preact/hooks';

export const useDateFormat = (date: string | Date | number) => {
    const [formattedDate, setFormattedDate] = useState<string>('');

    useEffect(() => {
        if(typeof date === 'string'){
            date = parseInt(date);
        }
// ... existing code ...
if (!date) return;

const formatDate = (inputDate: string | Date | number) => {
    const d = new Date(inputDate);
    
    // Check if date is invalid
    if (isNaN(d.getTime())) {
        console.error('Invalid date input:', inputDate);
        return 'Invalid date';
    }
    
    // Format day, month, year
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(-2);
    
    // Format hours and minutes
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');

    return `${day}/${month}/${year} at ${hours}:${minutes}`;
};

setFormattedDate(formatDate(date));  // Remove toString() as it might cause issues
// ... existing code ...
    }, [date]);

    return formattedDate;
};